/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */

import React, { useEffect, useState, useCallback, useContext } from 'react';
import Toast from '../../../components/Toast';
import CardHeader from '../../../components/CardHeader';
import DropDownComponent from './Components/DropDownComponent';
import { dataService } from '../../../services/data.services';
import StudentListPopup from './Components/StudentListPopup';
import { Link, useNavigate } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import Loader from '../../../components/Loader';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { ShimmerTitle } from 'react-shimmer-effects';

const PromoteStudent = () =>{
    const {setToastmessage} = useContext(GlobalContext);
    const navigate = useNavigate()
    const openReorderClassesPage = () => {
        window.open('/main-hub/classes/reorder', '_blank', 'noopener,noreferrer');
    };
    const [academicYearsForCurrent, setAcademicYearsForCurrent] = useState([])
    const [academicYearsForPromote, setAcademicYearsForPromote] = useState([])
    const [classes, setClasses] = useState([])
    const [sectionsForCurrent, setSectionsForCurrent] = useState([])
    const [studentListLoader, setstudentListLoader] = useState(false)
    const [sectionsForPromtoe, setSectionsForPromtoe] = useState([])
    const [currentClassDetails, setCurrentClassDetails] = useState({
        academic_year : {},
        class: {},
        section: {}
    })
    const [promoteToClassDetails, setPromoteToClassDetails] = useState({
        academic_year : {},
        class: {},
        section: {},
    })
    const [noteField, setNoteField] = useState('')
    //c is short for 'current class' and p is short for 'to promote class'
    const [allFieldsValidation, setAllFieldsValidation]=useState({
        c_ay: false,
        p_ay: false,
        c_class: false,
        p_class: false,
        c_sec: false,
        p_sec: false,
    })
    const [studentAllData, setStudentAllData] = useState([])
    const [studentIdArray, setStudentIdArray] = useState([])
    const [viewStudentList, setViewStudentList] = useState(false)
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [apiIsLoading, setApiIsLoading] = useState(false)
    const [currentSectionLoading,setCurrentSectionLoading] = useState(false)
    const [promoteSectionLoading,setPromoteSectionLoading] = useState(false)

    const [currentAYLoading,setCurrentAYLoading] = useState(false)
    const [promoteAYLoading,setPromoteAYLoading] = useState(false)
    const [classLoading,setClassLoading] = useState(false)

    const arrayToMapForCurrent = Array.isArray(academicYearsForCurrent)
        ? academicYearsForCurrent
        : [academicYearsForCurrent];

    const arrayToMapForPromote = Array.isArray(academicYearsForPromote) 
        ? academicYearsForPromote
        : [academicYearsForPromote];

    const hasMissingClassDisplayOrder = classes?.some(
        (item) => item?.display_order === undefined || item?.display_order === null || item?.display_order === ''
    );
    const isPromotionLocked = classLoading || hasMissingClassDisplayOrder;
    const promoteableClasses = Object.keys(currentClassDetails.class).length === 0
        ? classes
        : classes.filter((item) => Number(item?.display_order) > Number(currentClassDetails.class?.display_order));
    const getNextClassForPromotion = (selectedCurrentClass) => {
        if (!selectedCurrentClass?._id || !Array.isArray(classes) || classes.length === 0) return {};

        const currentDisplayOrder = Number(selectedCurrentClass.display_order);
        const nextClasses = classes
            .filter((item) => Number(item?.display_order) > currentDisplayOrder)
            .sort((firstClass, secondClass) => Number(firstClass?.display_order) - Number(secondClass?.display_order));

        return nextClasses[0] || {};
    };

    /**
 * The function `updateNameWithStatus` takes an array of objects and returns a new array with each
 * object's name property updated to include the capitalized status.
 * @returns a new array where each item has its name updated with its status in parentheses.
 */
    function updateNameWithStatus(array) {
        return array?.map(item => {
            return {
                ...item,
                modified_name: `${item.name} (${new Date(item.start_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })} - ${new Date(item.end_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'UTC' })}) (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`
            };
        });
    }

    const updatedAcademicYearsDropdownOptionsForCurrent = updateNameWithStatus(arrayToMapForCurrent);
    const updatedAcademicYearsDropdownOptionsForPromote = updateNameWithStatus(arrayToMapForPromote);

    /**
     * The function `handleOnchangeInputForCurrentClass` updates the state variables
     * `promoteToClassDetails` and `currentClassDetails` based on the input values of `id`, `item`, and
     * `index`.
     */

    const handleOnchangeInputForCurrentClass = (id, item, index) => {
        if (isPromotionLocked) return;
        setToastErrorMessage('')
        setstudentListLoader(false);
        setStudentAllData([])
        setStudentIdArray([])
        setViewStudentList(false)
        setAllFieldsValidation({
            c_ay: false,
            p_ay: false,
            c_class: false,
            p_class: false,
            c_sec: false,
            p_sec: false,
        })
        setPromoteToClassDetails((prev)=>{
            return{
                ...prev,
                academic_year : {},
                class: {},
                section: {},
            }
        })
        setCurrentClassDetails((prev)=>{
            if(id === 'Academic Year-1'){
                return{
                    class: {},
                    section: {},
                    academic_year: item
                }
            }
            else if(id === 'Class-1'){
                const nextClass = getNextClassForPromotion(item);

                setPromoteToClassDetails((prev) => ({
                    ...prev,
                    class: nextClass,
                    section: {},
                }));

                if (Object.keys(nextClass).length === 0) {
                    setToastErrorMessage('No higher class available to promote students.');
                    setAllFieldsValidation((prev) => ({
                        ...prev,
                        p_class: true,
                    }));
                }

                return{
                    ...prev,
                    section: {},
                    class: item
                }
            }
            else if(id === 'Section-1'){
                return{
                    ...prev,
                    section: item
                }
            }
            return prev
        })

    }

    /**
     * The function `handleOnchangeInputForPromote` updates the state `promoteToClassDetails` based on the
     * selected values for academic year, class, and section.
     */
    const handleOnchangeInputForPromote = (id, item, index) => {
        if (isPromotionLocked) return;
        if(studentAllData?.length === 0) {
            setToastErrorMessage('No students available in the selected Section');
            return;
        }
        if(studentIdArray?.length === 0){
            setToastErrorMessage('Please select the students from the list')
            setPromoteToClassDetails((prev)=>{
                return{
                    ...prev,
                    academic_year : {},
                    class: {},
                    section: {},
                }
            })
            return;
        }else{
            setToastErrorMessage('')
            setAllFieldsValidation({
                c_ay: false,
                p_ay: false,
                c_class: false,
                p_class: false,
                c_sec: false,
                p_sec: false,
            })
            setPromoteToClassDetails((prev)=>{
                if(id === 'Academic Year-2'){
                    if(item.name === currentClassDetails.academic_year.name){
                        setToastErrorMessage("Student(s) cannot be promoted to same AY")
                        setAllFieldsValidation((prev)=>  {
                            return{
                                ...prev,
                                p_ay: true,
                            }
                        })
                        return{
                            ...prev,
                            class: {},
                            section: {},
                            academic_year: {}
                        }
                    } else {
                        return{
                            ...prev,
                            class: {},
                            section: {},
                            academic_year: item
                        }
                    }
                }
                else if(id === 'Class-2'){
                    if(
                        Object.keys(currentClassDetails.class).length !== 0 &&
                        Number(item?.display_order) <= Number(currentClassDetails.class?.display_order)
                    ){
                        setToastErrorMessage('Students can only be promoted to a class after the current class')
                        setAllFieldsValidation((prev)=>  {
                            return{
                                ...prev,
                                p_class: true,
                            }
                        })
                        return{
                            ...prev,
                            section: {},
                            class: {}
                        }
                    }
                    return{
                        ...prev,
                        section: {},
                        class: item
                    }
                }
                else if(id === 'Section-2'){
                    return{
                        ...prev,
                        section: item
                    }
                }
                return prev
            })
        }
    }

    const handlePromoteAndItsValidation = async() =>{
        if (isPromotionLocked) {
            setToastErrorMessage('Reorder classes before promoting')
            return
        }
        if (
            Object.keys(currentClassDetails.class).length !== 0 &&
            Object.keys(getNextClassForPromotion(currentClassDetails.class)).length === 0
        ) {
            setToastErrorMessage('No next class exists. Promotion cannot proceed.')
            setAllFieldsValidation((prev) => ({
                ...prev,
                p_class: true,
            }))
            return
        }
        if (
            Object.keys(currentClassDetails.class).length !== 0 &&
            Object.keys(promoteToClassDetails.class).length !== 0 &&
            Number(promoteToClassDetails.class?.display_order) <= Number(currentClassDetails.class?.display_order)
        ) {
            setToastErrorMessage('Students can only be promoted to a class after the current class')
            setAllFieldsValidation((prev) => ({
                ...prev,
                p_class: true,
            }))
            return
        }
        const branch_id = await GetBranchId()
        setApiIsLoading(true)

        let result = [];
        /* The below code is iterating over an array called `studentAllData` using the `forEach` method. For
        each item in the array, it checks if the `student_id` property of the item is included in another
        array called `studentIdArray`. If it is included, it creates a new object with the properties
        `student_name` and `student_id`, where `student_name` is the trimmed value of the `full_name`
        property of the item. This new object is then pushed into a result array. */
        studentAllData.forEach(item => {
            if (studentIdArray.includes(item.student_id)) {
                result.push({
                    "student_name": item.full_name.trim(),
                    "student_id": item.student_id ,
                    'student_uuid': item?._id
                });
            }
        });
        let body = {
            "students": result,
            "current_class": {
                "academic_year_id": currentClassDetails.academic_year._id,
                "class_id": currentClassDetails.class._id,
                "section_id": currentClassDetails.section._id,
                "section_name": currentClassDetails.section.name,
                "class_name": currentClassDetails.class.name,
                "academic_year_name": currentClassDetails.academic_year.name
            },
            "promoted_class": {
                "academic_year_id": promoteToClassDetails.academic_year._id,
                "class_id": promoteToClassDetails.class._id,
                "section_id": promoteToClassDetails.section._id,
                "section_name": promoteToClassDetails.section.name,
                "class_name": promoteToClassDetails.class.name,
                "academic_year_name": promoteToClassDetails.academic_year.name
            },
            "note": noteField,
            "branch_id": branch_id,
        }


        /**
         * The function creates a validation state object by checking if each value in the input state object
         * is empty or not.
         * @returns The function `createValidationState` returns an object `validationState` which contains the
         * validation state for each key in the input `state` object.
         */
        const createValidationState = (state) => {
            const validationState = {};
        
            const checkAndTrim = (value) => {
                if (typeof value === 'string') {
                    return value.trim() === '';
                } else if (typeof value === 'object' && value !== null) {
                    return Object.values(value).length === 0;
                } else {
                    return value === null || value === undefined;
                }
            };
        
            for (const key in state) {
                if (state.hasOwnProperty(key)) {
                    validationState[key] = checkAndTrim(state[key]);
                }
            }
        
            return validationState;
        };

        const validationStateForCurrentClassDetails = createValidationState(currentClassDetails);
    
        const validationStateForPromoteToClassDetails = createValidationState(promoteToClassDetails);
    
        const newValidationState = {
            c_ay: validationStateForCurrentClassDetails.academic_year,
            p_ay: validationStateForPromoteToClassDetails.academic_year,
            c_class: validationStateForCurrentClassDetails.class,
            p_class: validationStateForPromoteToClassDetails.class,
            c_sec: validationStateForCurrentClassDetails.section,
            p_sec: validationStateForPromoteToClassDetails.section,
        };
    
        setAllFieldsValidation(newValidationState);
    
        // Check if any validation state is true
        const isAnyValidationTrue = Object.values(newValidationState).some((value) => value);
    
        if (isAnyValidationTrue) {
            setToastErrorMessage('Please fill in all the mandatory fields');
            setApiIsLoading(false)
            return
        } else if (studentIdArray?.length === 0) {
            setToastErrorMessage('Please select the students from the list');
            setApiIsLoading(false)
            return
        } else {
            try{
                let response = null
                response = await dataService.PostAPI(body, 'promote-students');
                if(response.data.status === 201){
                    navigate('/student-master/promote-history')
                    setToastmessage(response?.data?.data?.message)
                }
            } catch(error) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
                setApiIsLoading(false)
            } finally {
                setApiIsLoading(false)
            }
        }
    }

    /**
     * The function `getAcademicyearsAPI` makes two API calls to retrieve academic years data and sets the
     * data in two different states.
     */
    const getAcademicyearsAPI = async (id) => {
        const branch_id = await GetBranchId()
        setCurrentAYLoading(true)
        let endpoint = `academic-years?filter=true&branch_id=${branch_id}&status=ongoing,completed&role=promote-students`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        
        setPromoteAYLoading(true)
        let endpoint2 = `academic-years?filter=true&branch_id=${branch_id}&status=ongoing,upcoming&role=promote-students`
        const response2 = await dataService.GetAPI(endpoint2, true);
        const temp2 = (response2.data?.data?.data);
        setAcademicYearsForCurrent(temp)
        setAcademicYearsForPromote(temp2)

        setCurrentAYLoading(false)
        setPromoteAYLoading(false)
    }

    /**
     * The function `getClassesAPI` makes an asynchronous API call to retrieve classes data and sets the
     * retrieved data to the `classes` state variable.
     */
    const getClassesAPI = async () => {
        const branch_id = await GetBranchId()
        setClassLoading(true)
        let endpoint = `classes?branch_id=${branch_id}&filter=true&status=true&role=promote-students`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setClasses(temp)
        setClassLoading(false)
    }

    /**
     * The function `getSectionAPIForCurrent` retrieves sections for the current academic year and class
     * from an API and sets them in the state.
     */
    const getSectionAPIForCurrent = async() => {
        const branch_id = await GetBranchId()
        if(academicYearsForCurrent?.length !== 0 && classes?.length !== 0 && Object.keys(currentClassDetails.academic_year).length !== 0 && Object.keys(currentClassDetails.class).length !== 0)
        {
            setCurrentSectionLoading(true)
            let endpoint = `associations?branch_id=${branch_id}&academic_year_id=${currentClassDetails.academic_year._id}&class_id=${currentClassDetails.class._id}&filter=true&role=promote-students`;
            const response = await dataService.GetAPI(endpoint, true);
            const temp = response.data?.data?.data;
            
            setSectionsForCurrent(temp.map(obj=>{
                return{
                    "name":obj.section_name,
                    "_id":obj.section_id,
                    "subjects":obj.subjects
                }}))
            setCurrentSectionLoading(false)
        }
    }

    /**
     * The function `getSectionAPIForPromote` retrieves sections for promotion based on certain conditions
     * and sets them in the state.
     */
    const getSectionAPIForPromote = async() => {
        const branch_id = await GetBranchId()
        if(academicYearsForPromote?.length !== 0 && classes?.length !== 0 && Object.keys(promoteToClassDetails.academic_year).length !== 0 && Object.keys(promoteToClassDetails.class).length !== 0)
        {
            setPromoteSectionLoading(true)
            let endpoint = `associations?branch_id=${branch_id}&academic_year_id=${promoteToClassDetails.academic_year._id}&class_id=${promoteToClassDetails.class._id}&filter=true&role=promote-students`;
            const response = await dataService.GetAPI(endpoint, true);
            const temp = response.data?.data?.data;
            setSectionsForPromtoe(temp.map(obj=>{
                return{
                    "name":obj.section_name,
                    "_id":obj.section_id,
                    "subjects":obj.subjects
                }}))
            setPromoteSectionLoading(false)
        }
    }

    /* The below code is defining a function called `getStudentOfCurrentClass` using the `useCallback` hook
    in React. This function is an asynchronous function that retrieves student data based on the current
    class details. */
    const getStudentOfCurrentClass = useCallback(async () => {
        const branch_id = await GetBranchId()
        if (Object.keys(currentClassDetails.academic_year).length !== 0 && Object.keys(currentClassDetails.class).length !== 0 && Object.keys(currentClassDetails.section).length !== 0) {
            const response = await dataService.GetAPI(`students?filter=true&status=active&branch_id=${branch_id}&class_id=${currentClassDetails.class._id}&section_id=${currentClassDetails.section._id}&academic_year_id=${currentClassDetails.academic_year._id}&is_academic_year=true&role=promote-students`, true);
            setStudentAllData(response?.data?.data?.students)
            setStudentIdArray(response?.data?.data?.students.map(obj => obj.student_id))
            setstudentListLoader(true)
        }
    }, [currentClassDetails.academic_year, currentClassDetails.class, currentClassDetails.section]);

    /* The below code is using the `useEffect` hook in a React component. It is calling two API functions,
    `getAcademicyearsAPI()` and `getClassesAPI()`, when the component is mounted for the first time. The
    `[]` as the second argument to `useEffect` ensures that the effect is only run once, when the
    component is mounted. */
    useEffect(()=>{
        getAcademicyearsAPI(),
        getClassesAPI()
    },[])

    /* The below code is a useEffect hook in a React component. It is triggered whenever the value of the
    "currentClassDetails" variable changes. */
    useEffect(()=>{
        if(academicYearsForCurrent?.length !== 0 && classes?.length !== 0 && Object.keys(currentClassDetails.academic_year).length !== 0 && Object.keys(currentClassDetails.class).length !== 0){
            getSectionAPIForCurrent()
            if(sectionsForCurrent?.length!==0 && Object.keys(currentClassDetails.section).length !==0){
                getStudentOfCurrentClass()
            }
        }else{
            setSectionsForCurrent([])
        }
    },[currentClassDetails])

    /* The below code is using the useEffect hook in React to perform a conditional check. It checks if the
    arrays `academicYearsForPromote` and `classes` are not empty, and if the
    `promoteToClassDetails.academic_year` and `promoteToClassDetails.class` are not empty strings. If
    all these conditions are met, it calls the `getSectionAPIForPromote` function. Otherwise, it sets
    the `sectionsForPromote` state to an empty array. This useEffect hook will be triggered whenever the
    `promoteToClassDetails` state changes. */
    useEffect(()=>{
        if(academicYearsForPromote?.length !== 0 && classes?.length !== 0 && Object.keys(promoteToClassDetails.academic_year).length !== 0 && Object.keys(promoteToClassDetails.class).length !== 0){
            getSectionAPIForPromote()
        } else{
            setSectionsForPromtoe([])
        }
    },[promoteToClassDetails])

    useEffect(() => {
        if (isPromotionLocked) {
            setViewStudentList(false)
            return
        }

        if (
            Object.keys(currentClassDetails.class).length !== 0 &&
            Object.keys(promoteToClassDetails.class).length !== 0 &&
            Number(promoteToClassDetails.class?.display_order) <= Number(currentClassDetails.class?.display_order)
        ) {
            setPromoteToClassDetails((prev) => ({
                ...prev,
                class: {},
                section: {},
            }))
            setSectionsForPromtoe([])
        }
    }, [isPromotionLocked, currentClassDetails.class, promoteToClassDetails.class])

    useEffect(() => {
        if (isPromotionLocked || Object.keys(currentClassDetails.class).length === 0) return;

        const nextClass = getNextClassForPromotion(currentClassDetails.class);

        if (Object.keys(nextClass).length === 0) {
            setPromoteToClassDetails((prev) => ({
                ...prev,
                class: {},
                section: {},
            }));
            return;
        }

        if (promoteToClassDetails.class?._id !== nextClass._id) {
            setPromoteToClassDetails((prev) => ({
                ...prev,
                class: nextClass,
                section: {},
            }));
        }
    }, [isPromotionLocked, currentClassDetails.class, classes, promoteToClassDetails.class?._id])

    return (
        <CardHeader noPadding >
            {/* Top bar */}
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky"}}
            >
                <div className="flex">
                    <h5 className="text-2xl font-bold text-[#031624] adderror">
                        Promote Students
                    </h5>
                </div>
                
                <div className="flex items-center">
                    <Link to={'/student-master/promote-history'} id='cancel' data-testid='cancel' className="cancl-btn">
                        Cancel
                    </Link>
                    <button id='approve' data-testid='approve' 
                        onClick={handlePromoteAndItsValidation}
                        disabled={isPromotionLocked || apiIsLoading}
                        style={isPromotionLocked ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
                        className="actn-btn">
                        {apiIsLoading ? <Loader/> : 'Approve'}
                    </button>
                </div>   
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            {/* Main body */}
            <div class="mainDataCntnrPageDiv scrollBlue_thick">
                <div className='flex justify-center items-center   '>
                    <div className="flex justify-center items-center gap-2.5 pl-[0.8125rem] pr-[0.8125rem] p-2 rounded-sm border border-[#c2dcef] bg-[#eef7fe] text-black text-center leading-6" style={{'width':'770px'}}>
                        Please select ‘Academic Year’, ’Class’ and ’Section’ to select students and promote
                    </div>
                </div>
                {hasMissingClassDisplayOrder && (
                    <div
                        className='flex justify-center items-center mt-2 '
                    >
                        <div className="underline flex justify-center cursor-pointer items-center gap-2.5 pl-[0.8125rem] pr-[0.8125rem] p-2 rounded-sm border border-[#FECACA] bg-[#FEF2F2] text-[#B42318] text-center leading-6" style={{'width':'770px'}}
                            onClick={openReorderClassesPage}    
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    openReorderClassesPage();
                                }
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            Click to reorder classes before promoting students
                        </div>
                    </div>
                )}
                <div className='flex justify-center items-center mt-4'>
                    <div className="flex justify-center items-start p-[16px] min-h-[18.5625rem] border border-[#d0d5dd]" style={{'width':'770px'}}>
                        {/* Current class Dropdowns */}
                        <div className='w-[65%]'>
                            <p className="text-f7 font-semibold text-[#031624] pb-3">Current Class</p>
                            {/* Academic Year Dropdown for Current class */}
                            <div className="flex items-center w-full mb-[16px]">
                                <label className="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Academic Year</label>
                                <DropDownComponent
                                    dropDownName={"Academic Year-1"}
                                    id={"Academic Year-1"}
                                    test_id={"Academic Year-1"}
                                    divClassName={`relative w-[200px] z-60`}
                                    buttonDisabled={isPromotionLocked}
                                    applyBGForDisabled={true}
                                    value={Object.keys(currentClassDetails.academic_year).length !== 0 ? currentClassDetails.academic_year.modified_name : ''}
                                    placeHolder={"Select Year"}
                                    showErrorBorder={allFieldsValidation.c_ay }
                                    options={updatedAcademicYearsDropdownOptionsForCurrent}
                                    handleOnchangeInput={handleOnchangeInputForCurrentClass}
                                    optionsKey={'modified_name'}
                                    listWidth={academicYearsForCurrent?.length === 0?`200px`:'250px'}
                                    tooltip={true} 
                                    loading={currentAYLoading}/>
                            </div>
                            {/* Class Dropdown for Current class */}
                            <div className="flex items-center w-full mb-[16px]">
                                <label className="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Class</label>
                                <DropDownComponent
                                    dropDownName={"Class-1"}
                                    id={"Class-1"}
                                    test_id={"Class-1"}
                                    divClassName={`relative w-[200px] z-60`}
                                    buttonDisabled={isPromotionLocked || currentClassDetails.academic_year._id === undefined || currentClassDetails.academic_year._id === ''}
                                    applyBGForDisabled={true}
                                    value={Object.keys(currentClassDetails.class).length !== 0 ? currentClassDetails.class.name : ''}
                                    placeHolder={"Select Class"}
                                    showErrorBorder={allFieldsValidation.c_class}
                                    options={classes}
                                    handleOnchangeInput={handleOnchangeInputForCurrentClass}
                                    tooltip={true} 
                                    loading={classLoading}/>
                            </div>
                            {/* Section Dropdown for Current class */}
                            <div className="flex items-center w-full mb-[16px]">
                                <label className="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Section</label>
                                <DropDownComponent
                                    dropDownName={"Section-1"}
                                    id={"Section-1"}
                                    test_id={"Section-1"}
                                    divClassName={`relative w-[200px] z-60`}
                                    buttonDisabled={isPromotionLocked || currentClassDetails.academic_year._id === undefined || currentClassDetails.academic_year._id === '' || 
                                    currentClassDetails.class._id === undefined || currentClassDetails.class._id === ''
                                    }
                                    applyBGForDisabled={true}
                                    value={Object.keys(currentClassDetails.section).length !== 0 ? currentClassDetails.section.name : ''}
                                    placeHolder={"Select Section"}
                                    showErrorBorder={allFieldsValidation.c_sec}
                                    options={sectionsForCurrent}
                                    handleOnchangeInput={handleOnchangeInputForCurrentClass}
                                    tooltip={true} 
                                    loading={currentSectionLoading}/>
                            </div>
                            {/* Student List */}
                            {Object.keys(currentClassDetails.academic_year).length !== 0 && Object.keys(currentClassDetails.class).length !== 0 && Object.keys(currentClassDetails.section).length !== 0 && <div className='flex' style={{'margin-left':'115px'}}>
                                <div className='flex items-center w-[70%]'>
                                    <p
                                        htmlFor='item_code'
                                        className={`text-f7 font-normal text-[#106EB4] inline-flex ${studentAllData?.length !== 0 && !isPromotionLocked ? 'cursor-pointer' : ''}`}
                                        onClick={() => studentAllData?.length !== 0 && !isPromotionLocked && setViewStudentList(true)}
                                        title={`${studentAllData?.length !== 0 && !isPromotionLocked ? 'Click to select Students' : ''}`}
                                    >

                                        {studentListLoader ?
                                            (studentAllData?.length !== 0 ?
                                                `${studentIdArray?.length} student(s) will be promoted ${Object.keys(promoteToClassDetails.academic_year).length !== 0 && Object.keys(promoteToClassDetails.class).length !== 0 && Object.keys(promoteToClassDetails.section).length !== 0 ?
                                                    'to ' + promoteToClassDetails.academic_year.name + ', ' + promoteToClassDetails.class.name + ', ' + promoteToClassDetails.section.name
                                                    : ''}`
                                                : 'No Students available in the selected section')
                                            : <p className="text-2xl font-bold text-[#031624] mb-1">
                                                <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]" />
                                            </p>}  
                                        {/* {`${studentIdArray?.length}`} student(s) will be promoted {`${ promoteToClassDetails.academic_year!== '' && promoteToClassDetails.class !== '' && promoteToClassDetails.section !=='' ? 'to '+promoteToClassDetails.academic_year.split('(')[0].trim()+', '+promoteToClassDetails.class+', '+promoteToClassDetails.section : ''}`} */}
                                    </p>
                                </div>
                            </div>}
                        </div>
                        {/* Promote To Dropdowns */}
                        <div className='ml-[10px]'>
                            <p className="text-f7 font-semibold text-[#031624] pb-3">Promote To</p>
                            {/* Academic Year Dropdown for Promotion class */}
                            <div className="flex items-center w-full mb-[16px]">
                                <label className="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Academic Year</label>
                                <DropDownComponent
                                    dropDownName={"Academic Year-2"}
                                    id={"Academic Year-2"}
                                    test_id={"Academic Year-2"}
                                    divClassName={`relative w-[200px] z-60`}
                                    value={Object.keys(promoteToClassDetails.academic_year).length !== 0 ? promoteToClassDetails.academic_year.modified_name : ''}
                                    placeHolder={"Select Year"}
                                    buttonDisabled={isPromotionLocked || academicYearsForPromote?.length === 0}
                                    applyBGForDisabled={true}
                                    showErrorBorder={allFieldsValidation.p_ay}
                                    options={updatedAcademicYearsDropdownOptionsForPromote}
                                    handleOnchangeInput={handleOnchangeInputForPromote}
                                    optionsKey={'modified_name'}
                                    listWidth={`250px`}
                                    tooltip={true} 
                                    loading={promoteAYLoading}/>
                            </div>
                            {/* Class Dropdown for Promotion class */}
                            <div className="flex items-center w-full mb-[16px]">
                                <label className="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Class</label>
                                <DropDownComponent
                                    dropDownName={"Class-2"}
                                    id={"Class-2"}
                                    test_id={"Class-2"}
                                    divClassName={`relative w-[200px] z-60`}
                                    buttonDisabled={true}
                                    applyBGForDisabled={true}
                                    value={Object.keys(promoteToClassDetails.class).length !== 0 ? promoteToClassDetails.class.name : ''}
                                    placeHolder={"Auto-selected"}
                                    showErrorBorder={allFieldsValidation.p_class}
                                    options={promoteableClasses}
                                    handleOnchangeInput={handleOnchangeInputForPromote}
                                    tooltip={true} 
                                    loading={classLoading}/>
                            </div>
                            {/* Section Dropdown for Promotion class */}
                            <div className="flex items-center w-full mb-[16px]">
                                <label className="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">Section</label>
                                <DropDownComponent
                                    dropDownName={"Section-2"}
                                    id={"Section-2"}
                                    test_id={"Section-2"}
                                    divClassName={`relative w-[200px] z-60`}
                                    buttonDisabled={isPromotionLocked || promoteToClassDetails.academic_year._id === undefined || promoteToClassDetails.academic_year._id === '' || 
                                    promoteToClassDetails.class._id === undefined || promoteToClassDetails.class._id === ''
                                    }
                                    applyBGForDisabled={true}
                                    value={Object.keys(promoteToClassDetails.section).length !== 0 ? promoteToClassDetails.section.name : ''}
                                    placeHolder={"Select Section"}
                                    showErrorBorder={allFieldsValidation.p_sec}
                                    options={sectionsForPromtoe}
                                    handleOnchangeInput={handleOnchangeInputForPromote}
                                    tooltip={true} 
                                    loading={promoteSectionLoading}/>
                            </div>
                            {/* Note Field*/}
                            <div className="flex w-full">
                                <label className="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex mt-[6px]">Notes</label>
                                <div className={`red-border1 w-[90%]`}>
                                    <textarea
                                        id={`Description`}
                                        maxLength={100}
                                        className={`txt-fld w-full ${isPromotionLocked ? 'bg-[#E6E8EA]' : ''}`}
                                        placeholder="Enter notes"
                                        value={noteField !== '' ? noteField : ''}
                                        disabled={isPromotionLocked}
                                        autoComplete='off'
                                        spellCheck='true'
                                        onChange={(event) =>{
                                            setNoteField(event.target.value)
                                        }}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*Student List Model*/}
            {viewStudentList && <StudentListPopup 
                setViewStudentList={setViewStudentList} 
                studentAllData={studentAllData} 
                studentIdArray={studentIdArray}
                setStudentIdArray={setStudentIdArray}
                setStudentAllData={setStudentAllData}
                setToastErrorMessage={setToastErrorMessage}
            />}
        </CardHeader>
    );
}


export default PromoteStudent;
